import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { IProviderSettings, IProviderSettingsListData } from './types';

const PROVIDER_SETTINGS_URL = 'api/v1/providers-settings';

export const fetchProviderSettingsListRequest = async ({
  page,
  size,
  ...data
}: IQueryParams): Promise<Partial<IProviderSettingsListData>> => {
  try {
    const res = await axios.post(PROVIDER_SETTINGS_URL, data, { params: { page, size } });
    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch provider settings");
    return {};
  }
};

export const updateProviderSettingsRequest = async ({
  id,
  declinedPaymentsCallbackDelayMinutes,
  ipWhiteList,
}: Partial<IProviderSettings>): Promise<Partial<IProviderSettings>> => {
  const res = await axios.put(`api/v1/providers/${id}/settings`, { declinedPaymentsCallbackDelayMinutes, ipWhiteList });
  return res.data;
};
